import { createFileRoute } from "@tanstack/react-router";
import { PageHeader, DataCard } from "@/components/admin/AdminPrimitives";
import { Settings, Globe, Mail, Shield, Palette } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/configuracoes")({
  head: () => ({ meta: [{ title: "Configurações — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: () => {
    const sections = [
      { icon: Globe, title: "Marca e domínio", desc: "Nome, logotipo, domínio principal e redirecionamentos." },
      { icon: Mail, title: "E-mails", desc: "Templates transacionais e remetentes." },
      { icon: Shield, title: "Segurança", desc: "Papéis, permissões, autenticação e auditoria." },
      { icon: Palette, title: "Aparência", desc: "Identidade visual e customizações da área de membros." },
      { icon: Settings, title: "Preferências", desc: "Fusos, idiomas e defaults da plataforma." },
    ];
    return (
      <div>
        <PageHeader title="Configurações" description="Ajustes globais da plataforma." />
        <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {sections.map((s) => {
            const Icon = s.icon;
            return (
              <DataCard key={s.title}>
                <div className="p-5">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--gray-soft)] text-[var(--navy)]">
                    <Icon size={16} />
                  </span>
                  <h3 className="mt-3 font-display text-base font-extrabold text-[var(--navy)]">{s.title}</h3>
                  <p className="mt-1 text-sm text-[var(--gray-ink)]">{s.desc}</p>
                </div>
              </DataCard>
            );
          })}
        </div>
      </div>
    );
  },
});
